<template>
  <div class="QuoteBlockRandom">
    <SpaceHandler :blok="showQuote" class="!bg-bg-brandStrong">
      <QuoteBlock :blok="showQuote" @click="circleQuote" />
    </SpaceHandler>
  </div>
</template>

<script setup lang="ts">
import { StoryBlokPropBase } from '~/constants/types/storyblok';
import { type QuoteBlockType } from '~/storyblok/QuoteBlock.vue';
import SpaceHandler from '~/components/body/SpaceHandler.vue';
import useStoryblokAdmin from '~/composeables/useStoryblokAdmin';
const { isInStoryblokAdmin } = useStoryblokAdmin();

type Props = StoryBlokPropBase & {
  quotes: QuoteBlockType[]
}

const props = defineProps<{
  blok: Props,
}>();

const randomQuote = ref(Math.floor(Math.random() * props.blok.quotes.length));
const showQuote = computed(()=> {
  return props.blok.quotes[randomQuote.value];
});

const circleQuote = () => {
  if (isInStoryblokAdmin()) {
    let newRandom = randomQuote.value + 1;

    if (newRandom > props.blok.quotes.length - 1) {
      newRandom = 0;
    }
    randomQuote.value = newRandom;
  }
};

</script>

<style scoped lang="postcss">
</style>
